import {
  actualizarIndicador,
  crearIndicador,
  eliminarIndicador,
  getIndicadores,
} from 'api/indicador'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import swal from 'sweetalert2'

const key = 'indicadores'
export function useObtenerIndicador(buscar) {
  return useQuery(key, () => getIndicadores(buscar))
}

export function useCrearIndicador() {
  const queryClient = useQueryClient()
  return useMutation(crearIndicador, {
    onSuccess: (response) => {
      const { data } = response
      queryClient.setQueryData(key, (prevState) => {
        const results = [data, ...prevState.results]
        return { ...prevState, results }
      })
    },
  })
}

export function useActualizarIndicador() {
  const queryClient = useQueryClient()
  return useMutation(actualizarIndicador, {
    onSuccess: (_, value) => {
      const { id, values: indicadorActualizado } = value
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.map((indicador) => {
          let nuevoIndicador = indicador
          if (id === indicador.id) {
            nuevoIndicador = indicadorActualizado
          }
          return nuevoIndicador
        })
        return { ...prevState, results }
      })
    },
  })
}

export function useEliminarIndicador() {
  const queryClient = useQueryClient()
  return useMutation(eliminarIndicador, {
    onSuccess: (_, value) => {
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.filter(
          (indicador) => indicador.id !== value.id,
        )
        return { ...prevState, results }
      })
    },
  })
}

export function useIndicador(onToggle) {
  const queryClient = useQueryClient()
  const { mutateAsync: eliminarIndicador } = useEliminarIndicador()
  const { mutateAsync: actualizarIndicador } = useActualizarIndicador()
  const { mutateAsync: crearIndicador } = useCrearIndicador()

  const handleCrearIndicador = async (values, acciones) => {
    try {
      const { data, onSuccessMessage } = await crearIndicador(values)
      const message = `El indicador ${data.nombre} fue creado satisfactoriamente!`
      onSuccessMessage({ text: message })
      acciones.resetForm()
      onToggle()
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleActualizarIndicador = async ({ id, values, acciones }) => {
    try {
      const { data, onSuccessMessage } = await actualizarIndicador({
        id,
        values,
      })
      if (data) {
        onSuccessMessage({
          text: 'El indicador fue actualizado satisfactoriamente!',
        })
        onToggle()
      }
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleEliminarIndicador = (id) => {
    swal
      .fire({
        title: 'Estás seguro?',
        text: 'Recuerda que no podrás revertir estos cambios!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminalo!',
      })
      .then(async ({ value }) => {
        if (value) {
          const { data, onSuccessMessage } = await eliminarIndicador(id)
          const message = `El indicador ${data} fue eliminado satisfactoriamente!`
          onSuccessMessage({ text: message })
        }
      })
  }

  const handleBuscarIndicador = async (value) => {
    queryClient.prefetchQuery(key, () => getIndicadores(value))
  }

  return {
    obtenerIndicadores: useObtenerIndicador,
    handleEliminarIndicador,
    handleActualizarIndicador,
    handleCrearIndicador,
    handleBuscarIndicador,
  }
}
